import styled from 'styled-components';
import { rem } from 'polished';
import TitleWidget from '../../core/TitleWidget';
import BoxInside from '../../core/BoxInside';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

const StyledBoxInside = styled(BoxInside)`
  padding-bottom: ${rem('80px')};
`;

const StyledTitleWidget = styled(TitleWidget)`
  line-height: ${rem('30px')};
  margin-bottom: ${rem('25px')};
  margin-left: ${rem('40px')};
  padding-left: ${rem('15px')};
  ${mediaqueries.greaterThan('tabletLandscape')`
    margin-left: ${rem('12px')};
    padding-left: ${rem('40px')};
  `};

  & > svg {
    left: ${rem('-42px')};

    bottom: 0;
    ${mediaqueries.greaterThan('tabletLandscape')`
      left: ${rem('-14px')};
      width: ${rem('48px')};
      height: ${rem('45px')};
    `};
  }
`;

export { StyledBoxInside, StyledTitleWidget };
